<template>
  <div id="layout-container" class="wrapper" :class="{'nav-open': $sidebar.showSidebar}" >
    <oci-session-management>
    </oci-session-management>
    <notifications></notifications>

    {{errorMessageCheck}}
    <div  @mouseover="mouseOver" @mouseout="mouseOut">
    <!--<div>-->
      <side-bar>
        <template slot-scope="props" slot="links">

          <user-menu></user-menu>

          <!-- DEVELOPER -->

          <sidebar-item v-if="$isAllowed('viewDeveloperDashboard')"
                        :link="{name: 'Developer', icon: 'now-ui-icons design-2_ruler-pencil'}">
            <sidebar-item
              :link="{name: 'Program Performance', icon: 'now-ui-icons files_paper', path: '/developer/ProgramPerformance'}"></sidebar-item>
            <sidebar-item v-if="$isAllowed('uploadProject')"
                          :link="{name: 'Program Administration', icon: 'now-ui-icons files_paper', path: '/developer/ProgramAdministration'}"></sidebar-item>
            <sidebar-item v-if="$isAllowed('initiateMarketing')"
                          :link="{name: 'Marketing & Communication', icon: 'now-ui-icons files_paper', path: '/developer/MarketingCommunication'}"></sidebar-item>
          </sidebar-item>


          <!-- LENDER -->

          <sidebar-item v-if="$isAllowed('viewLenderDashboard')"
                        :link="{name: 'Lender', icon: 'now-ui-icons business_bank'}">
            <sidebar-item
              :link="{name: 'Program Performance', icon: 'now-ui-icons business_bank', path: '/lender/program_performance'}">
            </sidebar-item>
            <!--<sidebar-item v-if="$isAllowed('viewLendingCriteria')"-->
            <!--:link="{name: 'Program Governance', icon: 'now-ui-icons files_paper', path: '/lender/program_governance'}">-->
            <!--</sidebar-item>-->
            <!--<sidebar-item-->
            <!--:link="{name: 'Conditions', icon: 'now-ui-icons business_bank', path: '/lender/conditions'}"></sidebar-item>-->
            <!--<sidebar-item-->
            <!--:link="{name: 'Client Management', icon: 'now-ui-icons business_bank', path: '/lender/lenderClientTable'}"></sidebar-item>-->
          </sidebar-item>


          <!-- ADMIN -->

          <sidebar-item v-if="$isAllowed('viewAdminDashboard')"
                        :link="{name: 'Administration', icon: 'now-ui-icons design_bullet-list-67'}">
            <sidebar-item
              :link="{name: 'Platform', icon: 'now-ui-icons design_app', path: '/admin/platform'}"></sidebar-item>
            <sidebar-item
              :link="{name: 'Program & Project', icon: 'now-ui-icons files_box', path: '/admin/program'}"></sidebar-item>
            <sidebar-item
              :link="{name: 'Firms & Representatives', icon: 'now-ui-icons files_paper', path: '/admin/firmrep'}"></sidebar-item>
            <sidebar-item
              :link="{name: 'Campaign Management', icon: 'now-ui-icons files_paper', path: '/admin/campaignManagement'}"></sidebar-item>
          </sidebar-item>


          <!-- ONECLOSE BROKER -->
          <!-- can't use the sidebar-item component without fully committing to it, so we are emulating it to get nesting-->

          <div v-if="$isAllowed('viewOciDashboard')">
            <li to="/" tag="li" class="">

              <a href="#"
                 data-toggle="collapse"
                 class="nav-link sidebar-menu-item"
                 :aria-expanded="collapsed"
                 @click.prevent="collapseMenu">
                <i class="now-ui-icons business_briefcase-24"></i>
                <p>OneClose<b class="caret"></b></p>
              </a>

              <!--<collapse-transition>-->
              <div v-show="collapsed">

                  <!--<div style="animation-fill-mode: both; animation-timing-function: ease-out;" data-old-padding-top="" data-old-padding-bottom="" data-old-overflow="">-->
                  <ul class="nav" style="margin-top:10px" >
                    <!--<router-link v-if="$isAllowed('viewBrokerChat')"
                      tag="li"
                      :to="{ path: '/broker/chat'}" >
                      <a class="nav-link">
                        &lt;!&ndash;<i class="now-ui-icons business_badge"></i>&ndash;&gt;
                        <span class="sidebar-mini-icon">BC</span>
                        <span class="sidebar-normal">Broker Chat</span>
                      </a>
                    </router-link>-->
                    <router-link
                      tag="li"
                      :to="{ path: '/broker/conditionsManagement'}" >
                      <a class="nav-link">
                        <span class="sidebar-mini-icon">CO<!--<i class="fa fa-tasks"></i>--></span>
                        <span class="sidebar-normal">Conditions Management</span>
                      </a>
                    </router-link>
                    <router-link
                      tag="li"
                      :to="{ path: '/broker/brokerpage'}" >
                      <a class="nav-link" @click="recentApps">
                        <span class="sidebar-mini-icon">CM<!--<i class="fa fa-tasks"></i>--></span>
                        <span class="sidebar-normal">Client Management</span>
                      </a>
                    </router-link>
                  </ul>

                <div v-if="$store.getters.showSideBar">
                  <!-- RECENT APPLICATIONS -->
                  <ul class="nav" style="margin:0;"
                      v-if="!withInMortgageApp && recentApplications && $store.getters.showSideBar">
                    <div v-for="(link,index) in recentApplications">
                      <li v-if="recentApplications"
                          v-bind:key="index"
                          style="margin-left:13px;"
                          @click="directToProfile(index)">
                        <a class="nav-link" style="padding:2px;">
                          <span class="sidebar-mini-icon"><i class="now-ui-icons users_circle-08 mt-2"></i></span>
                          <span class="sidebar-normal">
                              <span style="">{{link.firstName}} {{link.lastName }}</span>
                              <span style="display:block;margin-top:-8px">{{link.refCode}}</span>
                            </span>
                        </a>
                      </li>
                    </div>
                  </ul>

                  <ul v-if="withInMortgageApp" class="nav" style="margin-top:10px">
                    <!-- BACK BUTTON -->
                    <li @click="appSummary">
                      <a class="nav-link">
                        <span class="sidebar-mini-icon"><i class="fa fa-backward"></i></span>
                        <span class="sidebar-normal">App Summary</span>
                      </a>
                    </li>

                    <!-- MTG APP -->
                    <!-- <router-link
                       tag="li"
                       v-if="withInMortgageApp"
                       @click="jumpApplicant(0)"
                       :to="{ path: appId}" >
                       <a class="nav-link" style="padding:2px;">
                           <span class="sidebar-mini-icon">
                             <i class="fa fa-clipboard mt-2"></i>
                           </span>
                         <span class="sidebar-normal">
                           <span style=""><strong>Mortgage Application</strong></span>
                           <span style="display:block;margin-top:-8px"><strong>{{loanApplicationReferenceCode}}</strong></span>
                         </span>
                       </a>
                     </router-link>-->


                    <li @click="jumpApplicant(0)">
                      <a class="nav-link" style="padding:2px;">
                            <span class="sidebar-mini-icon">
                            <i class="fa fa-clipboard mt-2"></i>
                          </span>
                        <span class="sidebar-normal">
                              <span style=""><strong>Mortgage Application</strong></span>
                              <span style="display:block;margin-top:-8px">
                                {{loanApplicationReferenceCode}}
                              </span>
                            </span>
                      </a>
                    </li>

                    <!-- APPLICANTS -->
                    <ul class="nav"
                        style="margin:0;"
                        v-for="(applicant, index) in allApplicants"
                        v-if="allApplicants.length > 0">
                      <!--v-if="allApplicants.length > 0 && ($sidebar.showSidebar || show)">-->
                      <li v-bind:key="index" @click="jumpApplicant(index)">
                        <a class="nav-link" style="padding:2px;">
                            <span class="sidebar-mini-icon">
                              <i class="now-ui-icons users_circle-08 mt-2"></i>
                            </span>
                          <span class="sidebar-normal">
                              <span style=""><strong>{{applicant.applicantType}}</strong></span>
                              <span style="display:block;margin-top:-8px">
                                {{applicant.applicant.personProfile.name.firstName + ' '
                                + applicant.applicant.personProfile.name.lastName}}
                              </span>
                            </span>
                          </a>
                        </li>
                        <li @click="jumpEmployment(index)" style="margin-left:13px;">
                          <a class="nav-link" style="margin-top:0;margin-bottom:0;">
                            <span class="sidebar-mini-icon"><i class="fa fa-briefcase"
                                                               style="font-size:16px;"></i></span>
                            <span class="sidebar-normal">Employment</span>
                          </a>
                        </li>
                        <li @click="jumpAssets(index)" style="margin-left:13px;">
                          <a class="nav-link" style="margin-top:0;margin-bottom:0;">
                            <span class="sidebar-mini-icon"><i class="fa fa-credit-card"
                                                               style="font-size:16px;"></i></span>
                          <span class="sidebar-normal">Assets & Liabilities</span>
                        </a>
                      </li>
                      <li @click="jumpExistingProperties(index)" style="margin-left:13px;">
                        <a class="nav-link" style="margin-top:0;margin-bottom:0;">
                          <span class="sidebar-mini-icon"><i class="fa fa-home" style="font-size:16px;"></i></span>
                          <span class="sidebar-normal">Existing Properties</span>
                        </a>
                      </li>
                    </ul>

                    <!-- REMAINING MTG APP -->
                    <ul class="nav" style="margin:0;">
                      <li @click="jumpSubject">
                        <a class="nav-link" style="margin-top:0;margin-bottom:0;">
                          <span class="sidebar-mini-icon"><i class="fa fa-building-o"></i></span>
                          <span class="sidebar-normal">Subject Property</span>
                        </a>
                      </li>
                    </ul>
                    <ul class="nav" style="margin:0;">
                      <li @click="jumpFinancing">
                        <a class="nav-link" style="margin-top:0;margin-bottom:0;">
                          <span class="sidebar-mini-icon"><i class="fa fa-gavel"></i></span>
                          <span class="sidebar-normal">Financing</span>
                        </a>
                      </li>
                    </ul>
                    <ul class="nav" style="margin:0;">
                      <li @click="jumpDownPayment">
                        <a class="nav-link" style="margin-top:0;margin-bottom:0;">
                          <span class="sidebar-mini-icon"><i class="fa fa-money"></i></span>
                          <span class="sidebar-normal">Down Payments</span>
                        </a>
                      </li>
                    </ul>
                    <ul class="nav" style="margin:0;">
                      <li @click="jumpLenderSubmit">
                        <a class="nav-link" style="margin-top:0;margin-bottom:0;">
                          <span class="sidebar-mini-icon"><i class="fa fa-balance-scale"></i></span>
                          <span class="sidebar-normal">Lender Submit</span>
                        </a>
                      </li>
                    </ul>
                    <ul class="nav" style="margin:0;">
                      <li @click="redirectToForms">
                        <a class="nav-link" style="margin-top:0;margin-bottom:0;">
                          <span class="sidebar-mini-icon"><i class="fa fa-paperclip"></i></span>
                          <span class="sidebar-normal">Forms</span>
                        </a>
                      </li>
                    </ul>
                    <ul class="nav" style="margin:0;">
                      <li @click="redirectToForms">
                        <a class="nav-link" style="margin-top:0;margin-bottom:0;">
                          <span class="sidebar-mini-icon"><i class="fa fa-wrench"></i></span>
                          <span class="sidebar-normal">Tools</span>
                        </a>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
              <!--</collapse-transition>-->
            </li>
          </div>


          <!-- PARTNER-->

          <sidebar-item v-if="$isAllowed('viewPartnerDashboard')" :link="{name: 'Partners', icon: 'fa fa-handshake-o'}">
            <sidebar-item
              :link="{name: 'Program Performance', icon: 'now-ui-icons files_paper', path: '/partner/program_performance'}">
            </sidebar-item>
            <sidebar-item
              :link="{name: 'Invoicing', icon: 'now-ui-icons files_single-copy-04', path: '/partner/invoicing'}">
            </sidebar-item>
            <sidebar-item
              :link="{name: 'Accounting', icon: 'now-ui-icons files_single-copy-04', path: '/partner/accounting'}">
            </sidebar-item>
          </sidebar-item>

         </template>
      </side-bar>
    </div>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <router-view name="header"></router-view>
      <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">

        <zoom-center-transition :duration="200" mode="out-in">
          <div class="oc-header-page-margin">
            <router-view></router-view>
          </div>
        </zoom-center-transition>

        <div id="oc-right-sidebar" ref="ocRightSidebar" class="">
          <div class="oc-broker-chat-container" v-if="this.$store.getters.brokerMiniChatOpen">
            <broker-mini-chat></broker-mini-chat>
          </div>
          <div class="oc-notifications-view" v-if="this.$store.getters.notificationHistoryDisplay">
            <notifications-view>
            </notifications-view>
          </div>
        </div>
      </div>
    </div>
    <content-footer v-if="!$route.meta.hideFooter"></content-footer>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import NotificationsView from '@/common/components/notifications/NotificationsView.vue'
  import PerfectScrollbar from 'perfect-scrollbar'
  import 'perfect-scrollbar/css/perfect-scrollbar.css'
  import Auth from '@/common/components/auth/Auth.vue'
  import OciSessionManagement from '@/common/components/auth/OciSessionManagement.vue'
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './extra/MobileMenu.vue'
  import UserMenu from './extra/UserMenu.vue'
  import {SlideYDownTransition, ZoomCenterTransition} from 'vue2-transitions'
  import BrokerMiniChat from '@/broker/components/BrokerMiniChat.vue'
  import SidebarSubItem from "../../../components/layout/sidebar/SidebarSubItem";
  import swal from 'sweetalert2'
  import {CollapseTransition} from 'vue2-transitions';
  import * as perimeters from '@/perimeters'

    function hasElement(className) {
        return document.getElementsByClassName(className).length > 0;
    }

    function initScrollbar(className) {
        if (hasElement(className)) {
            new PerfectScrollbar(`.${className}`);
        } else {
            // try to init it later in case this component is loaded async
            setTimeout(() => {
                initScrollbar(className);
            }, 100);
        }
    }

    export default {
        data() {
            return {
                recentApp1: '',
                recentApp2: '',
                recentApp3: '',
                appId: '/broker/mortgageapp',
                asset: false,
                show: false,
                names: [],
                recent: false,
                showRightChat: false,
                showNotificationsView: false,
                isMtgAppLoaded: false,
                collapsed: true,
            }
        },
        perimeters: [
            perimeters.basePerimeters,
            perimeters.developerPerimeters,
            perimeters.lenderPerimeters,
            perimeters.administrationPerimeters,
            perimeters.ociPerimeters,
        ],
        components: {
            SidebarSubItem,
            TopNavbar,
            ContentFooter,
            DashboardContent,
            MobileMenu,
            UserMenu,
            SlideYDownTransition,
            ZoomCenterTransition,
            Auth,
            BrokerMiniChat,
            NotificationsView,
            CollapseTransition,
          OciSessionManagement
        },
        computed: {
            profile: {
                get() {
                    if (this.$store.getters.profileByUser) {
                        return this.$store.getters.profileByUser;
                    }
                }
            },
            withInMortgageApp: {
                get() {
                    return this.$store.getters.isWithinMortgageApp;
                }
            },
            loanApplicationReferenceCode: {
                get() {
                    if (this.$store.state.activeApplicationApplicant && this.$store.state.activeApplicationApplicant.loanApplication) {
                        return this.$store.state.activeApplicationApplicant.loanApplication.applicationReferenceCode;
                    }
                    return 'not found'
                }
            },
            errorMessageCheck: {
                get() {
                    if (this.$store.getters.getError !== null && this.$store.getters.suppressGlobalErrorMessage === false) {
                        this.displayErrorMessage(this.$store.getters.getError);
                    }
                }
            },
            guarontorCheck: {
                get() {
                    var checks = false;
                    for (var i = 0; i < this.$store.getters.allApplicationApplicants.length; i++) {
                        if (this.$store.getters.allApplicationApplicants[i].applicantType === "guarantor") {
                            checks = true;
                        }
                    }
                    return checks;
                }
            },
            coApplicantCheck: {
                get() {
                    var checks = false;
                    for (var i = 0; i < this.$store.getters.allApplicationApplicants.length; i++) {
                        if (this.$store.getters.allApplicationApplicants[i].applicantType === "coApplicant") {
                            checks = true;
                        }
                    }
                    return checks;
                }
            },
            theNames: {
                get() {
                    return this.names;
                }
            },
            allApplicants: {
                get() {
                    // this.withInMortgageApp = this.$crypto.decodeIdParam(this.$route.query.loanApp);
                    // console.info("$route > within mortgage app: " + this.withInMortgageApp)
                    // console.info(this.$store.getters.allApplicationApplicants)
                    return this.$store.getters.allApplicationApplicants;
                }
            },
            recentApplications: {
                get() {
                    if (this.$store.getters.getRecentApplications) {
                        return this.$store.getters.getRecentApplications;
                    }
                }
            },
        },
        methods: {
            redirectToForms() {
                // @TODO this needs to be worked on .. we need a form repository design session and build
                console.warn('TODO > application.documents form repository for loan_application design and build')
                this.$router.push({path: '/documents/generic'});
            },
            appSummary() {
                let encryptAppApplicationId = this.$crypto.encodeIdParam(String(this.$store.getters.activeApplicationApplicant.applicationApplicantId));
                let encryptLoanApplicationId = this.$crypto.encodeIdParam(String(this.$store.getters.activeApplicationApplicant.loanApplication.loanApplicationId));
                this.$router.push({path: '/broker/UserActivityDetailsWrapper?appApplicant=' + encryptAppApplicationId + '&loanApp=' + encryptLoanApplicationId});
                this.$store.commit('withinMortgageApp', false);
                // this.$store.commit('UPDATE_ALL_APPLICATION_APPLICANTS', null);
            },
            displayErrorMessage(errorMessage) {
                if (!errorMessage.title) {
                    errorMessage.title = "Application Message"
                }
                if (!errorMessage.type) {
                    errorMessage.type = "error"
                }
                let msg = "", html = "";
                if(errorMessage.ociMessage.includes(";")){
                    msg = errorMessage.ociMessage.split(';');
                    for(let i = 0; i < msg.length;i++){
                        html += msg[i] + "<br>";
                    }
                    html += "Error Code " + errorMessage.ociErrorIdentifier
                }
                else {
                    html = errorMessage.ociMessage + "<br/>" + "<strong> Error Code " + errorMessage.ociErrorIdentifier + "</strong>";
                }
                swal({

                    title: errorMessage.title,
                    type: errorMessage.type,
                    html: html,
                    // html: errorMessage.ociMessage + "<br/>" + "<strong> Error Code " + errorMessage.ociErrorIdentifier + "</strong>",
                    // text: errorMessage.ociMessage + "\n Error Code " + errorMessage.ociErrorIdentifier,
                    // type: 'warning',
                    showConfirmButton: true,
                    buttonsStyling: true,
                    confirmButtonText: "OK",
                    onClose: () => {
                        this.$store.commit("UPDATE_MESSAGE_SUPPRESSION", false)
                        this.$store.commit("ERROR", null);

                    }

        }).then((result) => {
          if(result.value) {
            // this.ociLog(result)
          }
        })
      },
      mouseOut() {
        // this.ociLog("...mouseOut");
        this.show=false;
      },
      mouseOver() {
        // this.ociLog("mouseOver...");
        this.show = true;
      },
      recentApps() {
        this.recent = !this.recent;
      },
      directToProfile(index) {
        let encryptAppApplicationId = this.$crypto.encodeIdParam(String(this.recentApplications[index].appId));
        let encryptLoanApplicationId = this.$crypto.encodeIdParam(String(this.recentApplications[index].loanAppId));

                let recentApps = JSON.parse(JSON.stringify(this.$store.getters.getRecentApplications));
                for (let i = 0; i < recentApps.length; i++) {
                    if (recentApps[i].loanAppId === this.recentApplications[index].loanAppId) {
                        recentApps.splice(i, 1);
                        recentApps.unshift({
                            appId: this.recentApplications[index].appId,
                            firstName: this.recentApplications[index].firstName,
                            lastName: this.recentApplications[index].lastName,
                            refCode: this.recentApplications[index].refCode,
                            loanAppId: this.recentApplications[index].loanAppId
                        });
                    }
                }
                this.$store.commit('UPDATE_RECENT_APPLICATIONS', recentApps);
                // let encrypt = this.$crypto.encodeIdParam(String(this.recentApplications[index].appId));

                // maybe props instead of the encrypt/decrypt param for this section.  need a think on it
                // letting the UAD page load its own state requirements
                /*console.info('PUSH TO: /UserActivityDetailsWrapper?appApplicant='
                  + this.$crypto.decodeIdParam(encryptAppApplicationId)
                  + '&loanApp='
                  + this.$crypto.decodeIdParam(encryptLoanApplicationId))*/

        this.$router.push({ path: '/broker/UserActivityDetailsWrapper?appApplicant=' + encryptAppApplicationId + '&loanApp=' + encryptLoanApplicationId})
      },
      jumpDownPayment() {
        let offsets = document.getElementById('downPayment').getBoundingClientRect();
        window.scrollBy({top: offsets.top - 150, behavior: 'smooth'});
      },
      jumpLenderSubmit() {
        let offsets = document.getElementById('submitToLender').getBoundingClientRect();
        window.scrollBy({top: offsets.top - 150, behavior: 'auto'});
      },
      jumpSubject() {
        let offsets = document.getElementById('loanInformation').getBoundingClientRect();
        window.scrollBy({top: offsets.top - 150, behavior: 'smooth'});
      },
      jumpApplicant(index) {
        let offsets = document.getElementById('showApplicantInformation' + index).getBoundingClientRect();
        window.scrollBy({top: offsets.top - 200, behavior: 'smooth'});
      },
      jumpFinancing() {
        let offsets = document.getElementById('financing').getBoundingClientRect();
        window.scrollBy({top: offsets.top - 150, behavior: 'smooth'});
      },
      jumpEmployment(index) {
        let offsets;
        this.$store.commit('setShowApplicant', {index: index, show: true});
        if(document.getElementById('applicantEmploymentForm' + index) !== null){
          offsets = document.getElementById('applicantEmploymentForm' + index).getBoundingClientRect();
          window.scrollBy({top: offsets.top - 190, behavior: 'smooth'});
        }
      },
      jumpAssets(index) {
        let offsets;
        this.$store.commit('setShowApplicant', {index: index, show: true});
        if(document.getElementById('assetsLiabilities' + index) !== null){
          offsets = document.getElementById('assetsLiabilities' + index).getBoundingClientRect();
          window.scrollBy({top: offsets.top - 190, behavior: 'smooth'});
        }
      },
      jumpExistingProperties(index) {
        this.$store.commit('setShowApplicant', {index: index, show: true});
        if(document.getElementById('existingProperties' + index) !== null) {
          var offsets = document.getElementById('existingProperties' + index).getBoundingClientRect();
          window.scrollBy({top: offsets.top - 190, behavior: 'smooth'});
        }
      },
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      showRightChatArea() {
        if (this.$store.getters.brokerChatPageOpen === true) {
          this.$store.dispatch('updateBrokerMiniChatOpen', false).then(() => {
          });

                } else {
                    this.$store.dispatch('updateBrokerMiniChatOpen', true).then(() => {
                    });
                }
            },
            handleCloseChat() {
                this.$store.dispatch('updateBrokerMiniChatOpen', false).then(() => {
                });

            },
            showNotificationsViewArea() {
                this.showNotificationsView = !this.showNotificationsView;
                this.updateNotificationDisplayState();

            },
            updateNotificationDisplayState() {
                this.$store.dispatch('setNotificationHistoryDisplay', this.showNotificationsView).then(() => {
                });

            },
            handleCloseNotifications() {
                this.showNotificationsView = false;
                this.updateNotificationDisplayState();
            },
            collapseMenu() {
                this.collapsed = !this.collapsed
            },
            getProfilePicture() {
                if (this.profile.profilePicture != null) {
                    let last = this.profile.profilePicture.lastIndexOf('/');
                    let key = this.profile.profilePicture.substr(last + 1, this.profile.profilePicture.length);
                    let formData = new FormData();
                    formData.append('file', key);
                    formData.append('profId', this.profile.profileId);
                    this.$store.dispatch('previewProfilePic', formData);
                } else {
                    if (this.profile.profileId) {
                        let key = "";
                        let formData = new FormData();
                        formData.append('file', key);
                        formData.append('profId', this.profile.profileId);
                        this.$store.dispatch('previewProfilePic', formData);
                    }
                }
            },
        },
        mounted() {

      this.$store.dispatch('loadProfileByUserId', this.$store.getters.appUser.userId)
      // let decoded = jwt_decode(localStorage.getItem('user-token'));
      // this.$store.dispatch('LOAD_APP_USER',decoded);
      if (this.link && this.link.collapsed !== undefined) {
        this.collapsed = this.link.collapsed
      }
      if (this.isActive && this.isMenu) {
        this.collapsed = false
      }
    },
    watch: {
      $route: {
        immediate: true,
        handler() {
          let recentApps = [], appAppIds = [];
          // this.ociLog("recent...")
          recentApps = JSON.parse(this.$crypto.decryptParam(localStorage.getItem('a')));
          if (recentApps.length > 0) {
            for (let i = 0; i < recentApps.length; i++) {
              if (appAppIds.includes(recentApps[i].loanAppId)) {
                recentApps.splice(i, 1);
              } else {
                appAppIds.push(recentApps[i].loanAppId);
              }
            }
            // this.ociLog("recent 1...");
            // this.ociLog(recentApps);
            this.$store.commit('UPDATE_RECENT_APPLICATIONS', recentApps);
          }
        }
      },
      // recentApplications: { causes infinite loop due to computed..  if we want the watch, we refactor.
      // currently acts just like a created() would due to immediate: true.. only fires on page create
      profile: {
        handler() {
          this.getProfilePicture();
        }

      },
      /*recentsList: {
        immediate: true,
        handler() {
          let recentApps = [], appAppIds = [];
          this.ociLog("recent...")
          recentApps = JSON.parse(this.$crypto.decryptParam(localStorage.getItem('a')));
          for(let i = 0;i < recentApps.length;i++) {
            if (appAppIds.includes(recentApps[i].loanAppId)) {
              recentApps.splice(i, 1);
            }
            else {
              appAppIds.push(recentApps[i].loanAppId);
            }
          }
          this.$store.commit('UPDATE_RECENT_APPLICATIONS',recentApps);
        }
      }*/
    },
    async created() {
      // this.$store.dispatch('loadPerson', this.$store.getters.appUser.profileId);
      this.$store.dispatch('loadProfileByUserId');
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('sidebar-wrapper');

                docClasses.add('perfect-scrollbar-on')
            } else {
                docClasses.add('perfect-scrollbar-off')
            }
        }
    }

</script>
<style>
  .oc-header-page-margin {
    margin-top: 93px;
    margin-left: -10px;
    margin-right: -10px;
  }
</style>

<style lang="scss">
  $scaleSize: .95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }

  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }

  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }

  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }

  .submenu button > i {
    background-color: #007dc2;
    //size: 10px 40px;
    font-style: normal;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    width: 200px;
    text-align: left;
    color: red;
    font-size: 1px;
    border: 0;
    line-height: 1.6;
    padding-top: 2px;
    padding-left: 10px;
  }
  .applicantTypeHeader {
    width: 195px;
    text-align: left;
    color: white;
    font-size: 12px;
    box-sizing: border-box;
    margin: 10px 0 10px 30px;
    border: 0;
    text-transform: uppercase;
    font-weight: bold;
  }

  .names {
    font-size: 14px;

  }
  .submenu {
    background-color: #007dc2;
    width: 195px;
    text-align: left;
    color: white;
    font-size: 10px;
    box-sizing: border-box;
    margin: 2px 0 2px 30px;
    border: 0;
  }
  .submenu:hover, .submenu:active {
    /*background-color: rgba(255,255,255, .1);*/
    width: 195px;
    text-align: left;
    color: white;
    font-size: 10px;
    box-sizing: border-box;
    margin: 2px 0 2px 30px;
    border: 0;
    border-radius: 3px;
  }

  .submenuApplicantSection {
    margin-left: 13px;
  }
  .otherMenuOptions {
    background-color: #007dc2;
    width: 207px;
    text-align: left;
    color: white;
    font-size: 12px;
    font-weight: bold;
    box-sizing: border-box;
    margin: 10px 0 2px 28px;
    padding-left: 0;
    border: 0;

  }
  .otherMenuOptions:hover {
    /*background-color: rgba(255,255,255, .1);*/
    width: 207px;
    text-align: left;
    color: white;
    font-size: 12px;
    font-weight: bold;
    box-sizing: border-box;
    margin: 10px 0 2px 28px;
    padding-left: 0;
    border: 0;
    /*border-radius: 3px;*/
  }
  .submenuName {
    background-color: #007dc2;
    width: 207px;
    text-align: left;
    color: white;
    font-size: 10px;
    box-sizing: border-box;
    margin: 2px 0 2px 28px;
    padding-left: 0;
    border: 0;

  }

  .back {
    padding-left: 20px;
    font-size: 12px;
  }

  .backButton {
    background-color: #007dc2;
    width: 223px;
    height: 45px;
    size: 60px;
    text-align: left;
    color: white;
    font-size: 12px;
    box-sizing: border-box;
    margin: 2px 0 2px 18px;
    padding-left: 8px;
    border: 0;
    border-radius: 4px;
  }

  .backButton:hover {
    /*background-color: rgba(255,255,255, .1);*/
    width: 223px;
    height: 45px;
    text-align: left;
    color: white;
    box-sizing: border-box;
    margin: 2px 0 2px 18px;
    padding-left: 5px;
    border: 0;
    border-radius: 4px;
  }

  .submenuName:hover {
    /*background-color: rgba(255,255,255, .1);*/
    width: 207px;
    text-align: left;
    color: white;
    font-size: 10px;
    box-sizing: border-box;
    margin: 2px 0 2px 28px;
    padding-left: 0;
    border: 0;
    /*border-radius: 3px;*/
  }

  /* doesn't work with the active && hover.. background is white, so bleaches text */
  .sidebar .nav li:hover:not(:active) {
    color: white;
  }

  .submenu-item {
    background-color: #007dc2;
    //size: 10px 40px;
    width: 200px;
    height: 20px;
    text-align: left;
    color: white;
    font-size: 10px;
    border: 0;
    line-height: 1.6;
    padding-top: 2px;
    padding-left: 10px;
    display: block;

  }

  .submenu-item:hover {
    //background-color: #2ca8ff;
    /*background-color: rgba(255,255,255, .1);*/
    font-size: 11px;
    box-shadow: none;
    line-height: 1.6;
  }

  .oc-broker-chat-container {
    position: fixed;
    /*left: 70%;*/
    right: 20px;
    top: 62px;
    width: 400px;
    z-index: 8000;
  }

  .oc-notifications-view {
    position: fixed;
    left: 70%;
    top: 62px;
    width: 30%;
    z-index: 8200;
  }


</style>
